(function () {
  'use strict';

  var COLORS = ['#e21d69', '#ff4d8d', '#ff85ad', '#ffd166', '#ffffff', '#ffe0e5'];
  var DURATION_MS = 2400;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getDrawerRoot(sourceEl) {
    return (
      (sourceEl && sourceEl.closest('.bls-minicart-wrapper')) ||
      document.querySelector('.header_minicart.active .bls-minicart-wrapper') ||
      document.querySelector('.bls-minicart-wrapper')
    );
  }

  function createParticles(count, originX, originY, width, height) {
    var particles = [];
    var i;

    for (i = 0; i < count; i++) {
      var angle = (Math.random() * Math.PI * 2);
      var speed = 2 + Math.random() * 5;
      particles.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - (2 + Math.random() * 3),
        w: 4 + Math.random() * 5,
        h: 6 + Math.random() * 6,
        rot: Math.random() * 360,
        vr: (Math.random() - 0.5) * 14,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        alpha: 1,
        gravity: 0.12 + Math.random() * 0.08,
        drag: 0.985,
      });
    }

    return particles;
  }

  function fire(sourceEl) {
    if (prefersReducedMotion()) return;

    var drawer = getDrawerRoot(sourceEl);
    if (!drawer) return;

    if (getComputedStyle(drawer).position === 'static') {
      drawer.style.position = 'relative';
    }

    var existing = drawer.querySelector('.cart-shipping-confetti-canvas');
    if (existing) existing.remove();

    var canvas = document.createElement('canvas');
    canvas.className = 'cart-shipping-confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    drawer.appendChild(canvas);

    var drawerRect = drawer.getBoundingClientRect();
    var bar =
      (sourceEl && sourceEl.closest('.premium-cart-bar-card')) ||
      drawer.querySelector('.premium-cart-bar-card') ||
      sourceEl;

    canvas.width = Math.max(1, Math.floor(drawerRect.width));
    canvas.height = Math.max(1, Math.floor(drawerRect.height));

    var barRect = bar ? bar.getBoundingClientRect() : drawerRect;
    var originX = barRect.left + barRect.width * 0.5 - drawerRect.left;
    var originY = barRect.top + barRect.height * 0.45 - drawerRect.top;

    var ctx = canvas.getContext('2d');
    var particles = createParticles(90, originX, originY, canvas.width, canvas.height);
    var start = performance.now();

    function frame(now) {
      var elapsed = now - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(function (p) {
        p.vx *= p.drag;
        p.vy = p.vy * p.drag + p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        p.alpha = Math.max(0, 1 - elapsed / DURATION_MS);

        ctx.save();
        ctx.globalAlpha = p.alpha;
        ctx.fillStyle = p.color;
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rot * Math.PI) / 180);
        ctx.fillRect(-p.w * 0.5, -p.h * 0.5, p.w, p.h);
        ctx.restore();
      });

      if (elapsed < DURATION_MS) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
      }
    }

    requestAnimationFrame(frame);
  }

  function syncCartTimerVisibility(progressBar) {
    if (!progressBar) return;
    var isFree = progressBar.classList.contains('cart_shipping_free');
    var card = progressBar.closest('.premium-cart-bar-card');
    if (card) {
      var timer = card.querySelector('premium-cart-timer');
      if (timer) {
        if (isFree) {
          if (!timer.hidden) {
            timer.hidden = true;
            if (typeof timer.stop === 'function') {
              timer.stop();
            } else if (timer.animationFrameId) {
              cancelAnimationFrame(timer.animationFrameId);
              timer.animationFrameId = null;
            }
          }
        } else if (timer.hidden) {
          timer.hidden = false;
          if (typeof timer.ensureRunning === 'function') {
            timer.ensureRunning();
          } else if (typeof timer.init === 'function') {
            timer.init();
          }
        }
      }
    }
    var content = progressBar.closest('.bls-minicart-content');
    if (content) {
      content.querySelectorAll('.cart-countdown-time').forEach(function (el) {
        el.hidden = isFree;
      });
    }
  }

  function patchProgressBar() {
    var ProgressBar = customElements.get('free-ship-progress-bar');
    if (!ProgressBar || ProgressBar.prototype.__confettiPatched) return false;

    var originalInit = ProgressBar.prototype.init;
    var originalSetProgressBar = ProgressBar.prototype.setProgressBar;

    ProgressBar.prototype.setProgressBar = function (percent) {
      var wasFree = this.classList.contains('cart_shipping_free');
      originalSetProgressBar.call(this, percent);
      if (wasFree !== this.classList.contains('cart_shipping_free')) {
        syncCartTimerVisibility(this);
      }
    };

    ProgressBar.prototype.init = function (order) {
      var wasFree = this.classList.contains('cart_shipping_free');
      originalInit.call(this, order);
      syncCartTimerVisibility(this);
      if (window.PremiumCartTimer) {
        window.PremiumCartTimer.ensureRunning();
      }
      if (!wasFree && this.classList.contains('cart_shipping_free')) {
        fire(this);
      }
    };

    ProgressBar.prototype.__confettiPatched = true;
    document.querySelectorAll('free-ship-progress-bar').forEach(syncCartTimerVisibility);
    return true;
  }

  function boot() {
    if (patchProgressBar()) return;
    setTimeout(boot, 40);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.CartShippingConfetti = { fire: fire };
})();
